<template>
  <v-app class="singInBg">
    <v-dialog :value="true" persistent max-width="400px" hide-overlay>
      <v-card>
        <v-layout row wrap class="text-xs-center">
          <v-flex xs12 class="mt-3">
            <img src="../../../static/img/cmg_logo.png" alt="Chip Mong Industries" height="96">
          </v-flex>
          <v-flex xs12 class="ma-3">
            <span class="title">{{ isPasswordReset ? `Reset your password` : `Welcome back. Please sign in`}}</span>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>

        <v-card-text v-if="!isPasswordReset">
          <form @submit.prevent="formSubmit" data-vv-scope="formSignIn">
            <v-layout row wrap class="ml-3 mr-3">
              <v-flex xs12>
                <v-text-field @keyup.enter="formSubmit" required label="Employee ID" v-model="user.employee_id" v-validate="'required'" :error-messages="errors.collect('employee id')"
                  data-vv-name="employee id" prepend-icon="account_circle"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field @keyup.enter="formSubmit" required label="Password" v-model="user.password" v-validate="'required'" :error-messages="errors.collect('password')"
                  data-vv-name="password" :append-icon="e1 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e1 = !e1)"
                  :type="e1 ? 'password' : 'text'" prepend-icon="lock"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-btn block @click="formSubmit" color="primary" dark :loading="isSigning" :disable="isSigning">
                  sign in
                </v-btn>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>

        <v-card-actions v-if="!isPasswordReset">
          <v-spacer></v-spacer>
          <v-btn flat @click="isForgotPass = !isForgotPass">forgot password?</v-btn>
        </v-card-actions>

        <v-card v-if="isForgotPass" flat>
          <form @submit.prevent="submitForgotPass" data-vv-scope="formSendResetCode">
          <v-layout row wrap class="ml-3 mr-3">
            <v-flex xs12>
              <v-card-title>
                <div class="body-1">Please input your correct email. We will send reset code to you shortly.</div>
              </v-card-title>
            </v-flex>
            <v-flex xs12>
              <v-card-text>
                <v-text-field type="email" required label="Email" v-model="email" v-validate="'required|email'"
                  :error-messages="errors.collect('email')" data-vv-name="email" prepend-icon="email"></v-text-field>
              </v-card-text>
            </v-flex>
            <v-flex xs12>
              <v-card-actions>
                <v-btn block dark type="submit" :loading="isSending" color="primary" :disable="isSending">send</v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
          </form>
        </v-card>
        <v-card v-if="isPasswordReset">
          <v-card-text>
            <v-container grid-list-xs class="ma-0 pa-0" fluid>
              <form @submit.prevent="submitResetPassword"  data-vv-scope="formResetPassword">
                <v-layout row wrap class="ml-3 mr-3">
                  <v-flex xs12>
                    <v-text-field required label="Reset Code" v-model="reset.code" v-validate="'required|numeric'" :error-messages="errors.collect('reset code')"
                      data-vv-name="reset code"></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field required name="newPassword" label="New password" v-model="reset.new_password" v-validate="'required|min:6'"
                      :error-messages="errors.collect('new password')" data-vv-name="new password" :append-icon="e2 ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (e2 = !e2)" :type="e2 ? 'password' : 'text'"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field required name="confirmPassword" label="Password confirmation" v-model="reset.retype_password" v-validate="'required|confirmed:newPassword|min:6'"
                      :error-messages="errors.collect('password confirmation')" data-vv-name="password confirmation" :append-icon="e3 ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (e3 = !e3)" :type="e3 ? 'password' : 'text'"></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn block type="submit" color="primary" dark :loading="isSending" :disable="isSending">
                      reset password
                    </v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn block @click="onCancel" color="accent" dark>
                      cancel
                    </v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import * as types from '../../store/mutation-types'

export default {
  name: 'signin',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      email: null,
      isForgotPass: false,
      e1: true,
      e2: true,
      e3: true,
      isErr: false,
      alert: false,
      loader: null,
      user: {
        employee_id: '',
        password: ''
      },
      reset: {},
      isSending: false,
      isSigning: false,
      isError: false,
      snackbar: false,
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  computed: {
    ...mapGetters({
      err: 'getErr',
      token: 'getToken',
      activeUser: 'getActiveUser',
      isLoading: 'getLoading',
      getErrMessage: 'getErrMessage',
      getResponse: 'getResponse'
    }),
    errMessage: function () {
      return this.getErrMessage || ''
    },
    isPasswordReset () {
      return this.$store.state.users.isPasswordReset
    }
  },
  methods: {
    ...mapActions(['signIn', 'sendForgotPassCode', 'resetPasswordWithCode']),

    formSubmit () {
      this.$validator.validateAll('formSignIn').then(result => {
        if (result) {
          this.isSigning = true
          let payload = {
            user: this.user,
            redirect: this.$route.query.redirect
          }
          this.signIn(payload).then(() => {
            this.isSigning = false
            let response = this.getResponse
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Sign in successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    },

    submitForgotPass () {
      this.$validator.validateAll('formSendResetCode').then(result => {
        if (result) {
          this.isSending = true
          this.sendForgotPassCode({ email: this.email }).then(() => {
            this.isSending = false
            let response = this.getResponse
            if (response.status === 200) {
              this.isForgotPass = false
            }
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Reset code sent to your email successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    },

    submitResetPassword () {
      this.$validator.validateAll('formResetPassword').then(result => {
        if (result) {
          this.isSending = true
          this.resetPasswordWithCode(this.reset).then(() => {
            this.isSending = false
            let response = this.getResponse
            if (response.status === 200) {
              this.isForgotPass = false
            }
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Reset code sent to your email successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    },

    onCancel () {
      this.$store.commit(types.SET_PASSWORD_RESET_FLAG, false)
    }
  }
}
</script>

<style scoped>
.singInBg {
  background-color: #004f18 !important;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/Signin.vue